import { JsonDiscriminatorProperty, JsonObject, JsonProperty } from "ta-json";

import { VisualSearchResource } from "./visual-search-request-resource";

@JsonObject()
@JsonDiscriminatorProperty("image")
export class VisualSearchResponseResource extends VisualSearchResource {
    /**
     * The link to the thumbnail rendition of the asset that was chosen to find similar assets for.
     * Will be used to show in the filters.
     */
    @JsonProperty("imageLink")
    imageLink?: string;

    /**
     * This string is to remove some visual search data from the query.
     */
    @JsonProperty("removeQuery")
    removeQuery: string;

    constructor(init?: Partial<VisualSearchResponseResource>) {
        super(init);

        Object.assign(this, init);
    }
}
